import { FormValidation } from "@lib/types/form";
import { Validator } from "../Validator";

const updateCigProfileValidators = {
  cigID: (validation: FormValidation, value: any) => {
    new Validator(validation, value).exists().is("string");
  },
  subCategory: (validation: FormValidation, value: any) => {
    new Validator(validation, value).exists().is("string");
  },
};

export default updateCigProfileValidators;
